"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = require("@powerednow/complexData/entity");
const modelLookup_1 = require("../modelLookup");
const entity_2 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
// eslint-disable-next-line no-redeclare
class ContactToAddress extends complexData_1.default {
    static get allowedAssociations() {
        return {
            contact: {
                key: 'contact',
                instance: (0, modelLookup_1.complexFindModel)('Contact'),
                single: true,
                cascadeDelete: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().contact_id,
                    customer_id: this.Entity.getFieldSymbols().customer_id,
                },
            },
            address: {
                key: 'address',
                instance: (0, modelLookup_1.complexFindModel)('Address'),
                single: true,
                cascadeDelete: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().address_id,
                    customer_id: this.Entity.getFieldSymbols().customer_id,
                },
            },
            job: {
                key: 'job',
                instance: (0, modelLookup_1.complexFindModel)('Job'),
                cascadeDelete: false,
                condition: {
                    site_id: this.Entity.getForeignFieldSymbols().id,
                    customer_id: this.Entity.getFieldSymbols().customer_id,
                },
            },
            action: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                cascadeDelete: false,
                condition: {
                    site_id: this.Entity.getForeignFieldSymbols().id,
                },
            },
            customer: {
                key: 'customer',
                instance: (0, modelLookup_1.complexFindModel)('Customer'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getFieldSymbols().customer_id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            address: true,
            contact: true,
        };
    }
    async getEmailableContactMethods() {
        const contact = await this.getContact();
        return contact.findContactMethodsBy(async (contactMethod) => contactMethod.canEmail());
    }
    async initDefaultAssociatedItems() {
        await this.setContact({ customer_id: this.data.customer_id });
        await this.setAddress({ customer_id: this.data.customer_id });
    }
    async getSearchableFields() {
        const searchableFields = [];
        const contact = await this.getContact();
        if (contact) {
            searchableFields.push(...(await contact.getSearchableFields()));
        }
        const address = await this.getAddress();
        if (address) {
            searchableFields.push(...(await address.getSearchableFields()));
        }
        return searchableFields;
    }
    async copyData(item) {
        const { id, customer_id, contact_id, address_id, type, ...itemData } = item.data.getDataValues();
        const contact = await this.getContact();
        if (contact) {
            await contact.copyData(await item.getContact());
        }
        const address = await this.getAddress();
        if (address) {
            await address.copyData(await item.getAddress());
        }
        Object.assign(this.data, itemData);
        return this;
    }
    async prepareSearchField() {
        this.data.suppressEvents();
        this.data[entity_1.searchFieldSymbolValue] = (await this.getSearchableFields()).join(' ').toLowerCase();
        this.data.unSuppressEvents();
    }
    async isContactable(channels) {
        const contact = await this.getContact();
        return contact.isContactable(channels);
    }
}
ContactToAddress.Entity = entity_2.default;
ContactToAddress.modelProperties = modelProperties_1.default;
exports.default = ContactToAddress;
//# sourceMappingURL=../../../../src/models/contactToAddress/index.js.map